import { useCallback, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL, otherParty } from "../../../../config";
import LangContext from "../../../../contexts/LangContext";
import { getDistrictSummary, getPercentage, getProvinceSummary, translate, translateNumber, translatePercentage } from "../../../../helper";
import { LoaderCard } from "../../../common/Loader";
import Province1 from "../../../common/Maps/Province1";
import Province2 from "../../../common/Maps/Province2";
import Province3 from "../../../common/Maps/Province3";
import Province4 from "../../../common/Maps/Province4";
import Province5 from "../../../common/Maps/Province5";
import Province6 from "../../../common/Maps/Province6";
import Province7 from "../../../common/Maps/Province7";
import "./index.css";

const MapChart = (props) => {
  const { lang } = useContext(LangContext);
  const provinceData = props.data;
  let { win, lead, totalWin, totalLead, ern } = getProvinceSummary(provinceData, true);

  let independent = { party: "I", win: win.filter((w) => w.win > 0 && w.party.match(/I+\d/)).reduce((a, b) => a + b.win, 0) };
  let parties = win.filter((w) => w.win > 0 && !w.party.match(/I+\d/));

  win = [...parties, independent];

  independent = { party: "I", lead: lead.filter((w) => w.lead > 0 && w.party.match(/I+\d/)).reduce((a, b) => a + b.win, 0) };
  parties = lead.filter((w) => parties.find((p) => p.party === w.party) && !w.party.match(/I+\d/));

  lead = [...parties, independent];

  const showMapLegend = useCallback(
    (dId) => {
      const { tab } = props;
      const { id, districts } = provinceData;
      let legendInfo = { result: [], province: id };

      districts &&
        districts.forEach((dData) => {
          if (dData.id === dId) {
            const { win, lead } = getDistrictSummary(dData);
            win.forEach((data, i) => {
              const leadData = lead.find((l) => l.party === data.party);
              const result = { party: data.party, win: data.win, lead: leadData ? leadData.lead : 0 };
              legendInfo.result.push(result);
            });
          }
        });

      if (dId) {
        document.querySelector("#map_popup_district_link_pr").innerHTML = props.province.districts.find((dis) => dis.id === dId)["name_" + lang];
        document.querySelector("#map_popup_district_link_pr").setAttribute("href", "/result/" + (legendInfo.province ? legendInfo.province + "/" + dId : dId.split("-")[1]) + "?type=" + tab + "&lang=" + lang);
      }

      let result_template = '<tr><td><Link to="#party_link#"><img src="#party_symbol#" width="16px" height="16px"> #party_name#</Link></td><td>#win#</td><td>#lead#</td></tr>';

      let totalRow = "";
      legendInfo.result.forEach((result, i) => {
        let row = result_template;
        const party_link = "/candidates" + (legendInfo.result[i].party === "O" ? "" : "/" + legendInfo.result[i].party);
        const party = props.parties.find((par) => par.code === legendInfo.result[i].party) || otherParty;
        row = row.replace("#party_name#", party["short_name_" + lang] || party["name_" + lang]);
        row = row.replace("#party_symbol#", ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png");
        row = row.replace("#party_link#", party_link);
        row = row.replace("#win#", translateNumber(legendInfo.result[i].win, lang));
        row = row.replace("#lead#", translateNumber(legendInfo.result[i].lead, lang));
        totalRow += row;
      });

      document.querySelector("#sh-map-legend-pr table tbody").innerHTML = totalRow;
      document.querySelector("#sh-map-legend-pr").style.display = "block";
      document.querySelectorAll("svg path.district").forEach((e) => {
        e.style.opacity = 0.8;
      });
      document.querySelector("svg path#" + dId).style.opacity = 1;
    },
    [props, provinceData, lang]
  );

  useEffect(() => {
    let boxheight = document.querySelector("#sh-province-chart-summary .sh-widget-card").offsetHeight * 1;
    let chartHeight = boxheight / 2.22;
    let mainPageHeight = document.querySelector("#column-chart-province").clientHeight;
    if (chartHeight === 0) {
      if (mainPageHeight === 0) {
        mainPageHeight = 300;
      }
      chartHeight = mainPageHeight - 20 + "px";
    } else {
      chartHeight = chartHeight + "px";
    }

    new window.Highcharts.Chart({
      chart: {
        type: "column",
        renderTo: "column-chart-province",
        height: chartHeight,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        spacingBottom: 0,
        spacingTop: 10,
        spacingLeft: 10,
        spacingRight: 10,
        reflow: true,
      },
      xAxis: {
        categories: [translate("win", lang), translate("lead", lang)],
      },
      yAxis: {
        title: {
          useHTML: true,
          text: translate("ern", lang),
        },
        labels: {
          formatter: function () {
            return translateNumber(this.value, lang);
          },
        },
      },

      title: {
        text: "",
        align: "center",
        verticalAlign: "middle",
        y: 10,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        headerFormat: "<span style='font-size:10px'>{point.key}</span><table>",
        pointFormat: "<tr><td style='color:{series.color};padding:0'>{series.name}: </td><td style='padding:0'><b>{point.y}</b></td></tr>",
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: win.map((d, i) => {
        const partyDetail = props.parties.find((par) => par.code === d.party) || otherParty;
        return {
          name: [partyDetail["name_" + lang]],
          color: partyDetail.color,
          data: [d.win, lead[i].lead],
        };
      }),
    });

    if (props.province.districts.length > 0) {
      showMapLegend(props.province.districts[0].id);
      document.querySelector("svg path#" + props.province.districts[0].id).style.opacity = 1;
    }
  }, [lead, win, props, showMapLegend, lang]);

  const handleDistrictHover = (el) => {
    let id = el.target.id;
    showMapLegend(id);
  };

  const renderProvinceMap = (pid) => {
    const provincses = [
      <Province1 data={props.province} handleDistrictHover={handleDistrictHover} />,
      <Province2 data={props.province} handleDistrictHover={handleDistrictHover} />,
      <Province3 data={props.province} handleDistrictHover={handleDistrictHover} />,
      <Province4 data={props.province} handleDistrictHover={handleDistrictHover} />,
      <Province5 data={props.province} handleDistrictHover={handleDistrictHover} />,
      <Province6 data={props.province} handleDistrictHover={handleDistrictHover} />,
      <Province7 data={props.province} handleDistrictHover={handleDistrictHover} />,
    ];
    return provincses[pid - 1];
  };

  const provinceExtraInfo = { area_sq_km: 0, total_voter: 0, voting_booth: 0, total_direct_seat: 0 };
  const rtype = props.tab ? props.tab : "federal";
  props.province.districts.forEach((d) => {
    provinceExtraInfo.total_direct_seat += d.regions.filter((a) => a.rtype === rtype).length;
    provinceExtraInfo.area_sq_km += d.regions.filter((a) => a.rtype === "federal").reduce((a, b) => a + b.area_sq_km, 0);
    provinceExtraInfo.total_voter += d.regions.filter((a) => a.rtype === rtype).reduce((a, b) => a + b.total_voter, 0);
    provinceExtraInfo.voting_booth += d.regions.filter((a) => a.rtype === rtype).reduce((a, b) => a + b.voting_booth, 0);
  });

  return (
    <section id="sh-province-chart-summary" className="sh-province-chart-section">
      <div className="container pb-3">
        <div className="container-fluid card sh-card-map">
          {!props.fetched && <LoaderCard />}
          <div className="row" style={{ opacity: props.fetched ? "1" : 0.5 }}>
            <div className="col-md-12">
              <div className="sh-widget-card">
                <div className="sh-map-legend-pr d-none d-lg-blockk" id="sh-map-legend-pr" style={{ display: "none!important" }}>
                  <h4>
                    {translate("district", lang)} -{" "}
                    <a href="/" id="map_popup_district_link_pr">
                      ""
                    </a>
                  </h4>
                  <table className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>{translate("win", lang)}</th>
                        <th>{translate("lead", lang)}</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
                <div className="sh-map-legend-pr d-none d-sm-block">
                  <table className="table">
                    <tbody></tbody>
                    <tbody>
                      <tr>
                        <td className="sh-bold">{translate("area", lang)}</td>
                        <td className="sh-bold">{translateNumber(provinceExtraInfo["area_sq_km"].toFixed(2), lang)}</td>
                      </tr>
                      <tr>
                        <td className="sh-bold">{translate("total_voter", lang)}</td>
                        <td className="sh-bold">{translateNumber(provinceExtraInfo["total_voter"].toFixed(0), lang)}</td>
                      </tr>
                      <tr>
                        <td className="sh-bold">{translate("voting_booth", lang)}</td>
                        <td className="sh-bold">{translateNumber(provinceExtraInfo["voting_booth"].toFixed(0), lang)}</td>
                      </tr>
                      <tr>
                        <td className="sh-bold">{translate("seat", lang)}</td>
                        <td className="sh-bold">{translateNumber(provinceExtraInfo["total_direct_seat"].toFixed(0), lang)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <h3 className="text-center">
                  {props.province["name_" + lang]} <span className="total-er">{" (" + translate("total_ERN", lang) + ":" + translateNumber(ern, lang)})</span>
                </h3>
                <div className="row sh-map-province">
                  <div className="col-sm-6">{renderProvinceMap(props.province.id)}</div>
                  <div className="col-sm-6">
                    <div id="column-chart-province" className="text-center hidden-xs" style={{ display: "none" }}></div>
                  </div>
                </div>
                <div className="row sh-progress-stat">
                  {/* <div className="col-sm-6 col-xs-12">
                    <h4 className="text-center">{translate("win", lang)}</h4>
                    {win.map((w, i) => {
                      const party = props.parties.find((par) => par.code === w.party) || otherParty;
                      return (
                        <div key={i}>
                          <label className="sh-progress-bar-label" htmlFor="">
                            <img
                              src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                              alt={party.code.toUpperCase()}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                              }}
                              className="pull-left sh-party-symbol"
                              width="20px"
                              height="20px"
                            />
                            <Link to={"/candidates" + (w.party === "O" ? "" : "/" + w.party) + "?lang=" + lang}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link>
                          </label>
                          <span className="pull-right data">{translateNumber(w.win, lang)}</span>
                          <div className="progress">
                            <div className="progress-bar" role="progressbar" style={{ width: getPercentage(w.win, totalWin), backgroundColor: party.color, opacity: 1 }}>
                              {translatePercentage(w.win, totalWin, lang)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div>
                      <label className="sh-progress-bar-label" htmlFor=""></label>
                      <label>
                        <b>{translate("total", lang)}</b>
                      </label>
                      <span className="pull-right data">
                        <b>{translateNumber(totalWin, lang)}</b>
                      </span>
                    </div>
                  </div> */}
                  {/* <div className="col-sm-6 col-xs-12">
                    <h4 className="text-center">{translate("lead", lang)}</h4>
                    {lead.map((l, i) => {
                      const party = props.parties.find((par) => par.code === l.party) || otherParty;
                      return (
                        <div key={i}>
                          <label className="sh-progress-bar-label" htmlFor="">
                            <img
                              src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                              alt={party.code.toUpperCase()}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                              }}
                              className="pull-left sh-party-symbol"
                              width="20px"
                              height="20px"
                            />
                            <Link to={"/candidates" + (l.party === "O" ? "" : "/" + l.party) + "?lang=" + lang}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link>
                          </label>
                          <span className="pull-right data">{translateNumber(l.lead, lang)}</span>
                          <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: getPercentage(l.lead, totalLead), backgroundColor: party.color, opacity: 1 }}>
                              {translatePercentage(l.lead, totalLead, lang)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div>
                      <label className="sh-progress-bar-label" htmlFor=""></label>
                      <label>
                        <b>{translate("total", lang)}</b>
                      </label>
                      <span className="pull-right data">
                        <b>{translateNumber(totalLead, lang)}</b>
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapChart;
